import React from "react";
import { Card, Stack } from "react-bootstrap";

interface BedRowState {
  bed: any;
  question?: string;
  action: React.ReactNode;
  children?: React.ReactNode;
}

// One bed, as it appears wherever beds are listed for assignment - the Shelter room rows and
// the case housing flow both render this so a bed never looks like two different things.
const BedRow = ({ bed, question, action, children }: BedRowState) => {
  const occupied = !!bed.occupant_id;
  return (
    <Card className="bg-light mb-0">
      <Card.Body className="p-2">
        <Stack direction="horizontal" gap={3} className="justify-content-between">
          <div className="text-truncate align-self-center flex-fill" style={{ minWidth: 0 }}>
            <small className="fw-semibold">{bed.name}</small>
            {question ? (
              <small className="fw-bold"> — {question}</small>
            ) : (
              occupied && (
                <small className="text-muted">
                  {" "}
                  — {bed.firstname} {bed.lastname}
                </small>
              )
            )}
          </div>
          {action}
        </Stack>
        {children}
      </Card.Body>
    </Card>
  );
};

export default BedRow;
